module.exports = __webpack_public_path__ + "img/pic5.c46dd3c5.png";